import React from "react";
import { Card, CardContent, Typography, Slider } from "@mui/material";

const BudgetSlider = ({ orientation, onOrientationChange }) => {
  return (
    <Card
      sx={{
        backgroundColor: "#28293e",
        mb: 3,
        px: { xs: 1.5, sm: 4 },
        py: { xs: 2, sm: 5 },
        width: "80%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontSize: { xs: "0.9rem", sm: "1.25rem" },
            mb: { xs: 1.5, sm: 2 },
            textAlign: "center",
            color: "#fff",
          }}
        >
          Set your budget: {orientation}$
        </Typography>
        <Slider
          min={100}
          max={15000}
          value={orientation}
          onChange={(event, newValue) => onOrientationChange(newValue)}
          step={1}
          valueLabelDisplay="auto"
          marks={[
            { value: 1000, label: "Smallest system" },
            { value: 5000, label: "Medium system" },
            { value: 10000, label: "Large system" },
          ]}
          sx={{
            color: "#ff6f61",
            "& .MuiSlider-thumb": {
              backgroundColor: "#ff6f61",
            },
            "& .MuiSlider-markLabel": {
              color: "#fff",
              fontSize: { xs: "0.6rem", sm: "0.9rem" },
            },
          }}
        />
      </CardContent>
    </Card>
  );
};

export default BudgetSlider;
